import React, { useState, useEffect, useRef } from 'react';

import styles from '../styles/PromptManager.module.css';
import {
  FaAngleRight,
  FaAngleUp,
  FaAngleDown,
  FaEdit,
  FaTrashAlt,
  FaPencilAlt,
  FaUps,
  FaPlusSquare,
  FaRegPlusSquare,
} from 'react-icons/fa';
import zIndex from '@mui/material/styles/zIndex';
import { API_ENDPOINTS, HTTP_METHODS } from '../../../constants/appConstants';
import { apiRequest } from '../services/promptManagerService';
import { useAuth } from '../../../contexts/AuthContext';
import { Button } from '@mui/material';

const NodeDependencyDropDown = ({
  optionsData,
  isNodeDependencyButton,
  setIsNodeDependencyButton,
  nodeDependencies,
  setNodeDependencies,
  isNodeDependencyListVisible,
  setIsNodeDependencyListVisible,
  editNodeDependencyIndex,
  setEditNodeDependencyIndex,
  setSnackbarMessage,
  setSnackbarSeverity,
  setSnackbarOpen,
  addNodeDependency,
  isCardVisible,
  setIsCardVisible,
}) => {
  const { token, handleLogout } = useAuth();

  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  //const [isNodeDependencyListVisible, setIsNodeDependencyListVisible] = useState(false);

  const [isWorkflowOpen, setIsWorkflowOpen] = useState(false);
  const [isNodeOpen, setIsNodeOpen] = useState(false);
  const [isDependentNodeOpen, setIsDependentNodeOpen] = useState(false);
  const [savedWorkflows, setsavedWorkflows] = useState([]);

  const [workflowOptions, setWorkflowOptions] = useState([]);
  const [nodeOptions, setNodeOptions] = useState([]);
  const [dependentNodeOptions, setDependentNodeOptions] = useState([]);
  const [savedWorkflowNodeLabels, setsavedWorkflowNodeLabels] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedCategorySlug, setSelectedCategorySlug] = useState(null);

  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [selectedWorkflowId, setSelectedWorkflowId] = useState(null);

  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);

  const [selectedDependentNode, setSelectedDependentNode] = useState(null);
  const [selectedDependentNodeId, setSelectedDependentNodeId] = useState(null);

  const isFetched = useRef(false);

  // Fetch again when `categories` change
  //const [nodeDependencies, setNodeDependencies] = useState({});
  //const [isNodeDependencyButton, setIsNodeDependencyButton] = useState(true);

  // UseEffect to track all props

  const findRelevantLabelsList = async (dependenciesResponse) => {
    const savedWorkflowsResponse = await apiRequest(
      API_ENDPOINTS.WORKFLOW_LIST,
      HTTP_METHODS.POST,
      { deleted_at: 'null' },
      token,
      handleLogout
    );

    if (
      !Array.isArray(dependenciesResponse) ||
      dependenciesResponse.length === 0
    )
      return [];
    const mappedDependencies = dependenciesResponse.map((dep) => {
      const workflowDetails = savedWorkflowsResponse.find(
        (workflow) => workflow.id === dep.wfw_id
      );

      const workflowName = workflowDetails
        ? workflowDetails.workflow_name
        : null;
      const workflowCategory = workflowDetails
        ? workflowDetails.workflow_category
        : null;

      const allnodes = savedWorkflowsResponse.flatMap((item) =>
        item.workflow.nodes.map((node) => ({
          id: node.id, // Include the ID
          label: node.data.label, // Include the label
        }))
      );

      let workflowNodeDetails = null;
      let workflowDependentNodeDetails = null;
      let nodeLabelVal = null;
      let nodeDependentLabelVal = null;

      let nodeIdVal = null;
      let nodeDependentIdVal = null;

      if (workflowDetails) {
        workflowNodeDetails = allnodes.find(
          (item) => item.id === dep.wfw_node_id
        );
        workflowDependentNodeDetails = allnodes.find(
          (item) => item.id === dep.wfw_node_dependent_id
        );
        nodeLabelVal = workflowNodeDetails ? workflowNodeDetails.label : null;
        nodeDependentLabelVal = workflowDependentNodeDetails
          ? workflowDependentNodeDetails.label
          : null;
        nodeIdVal = workflowNodeDetails ? workflowNodeDetails.id : null;
        nodeDependentIdVal = workflowDependentNodeDetails
          ? workflowDependentNodeDetails.id
          : null;
      }

      return {
        id: dep.id,
        workflowCategory: workflowCategory,
        workflowName: workflowName,
        nodeLabel: nodeLabelVal,
        nodeDependentLabel: nodeDependentLabelVal,
        workflowCategoryId: dep.wfw_category,
        workflowNameId: dep.wfw_id,
        nodeId: dep.wfw_node_id,
        nodeDependentId: dep.wfw_node_dependent_id,
      };
    });

    // setsavedWorkflows(workflowCategoryArr);

    //setWorkflowOptions(workflowCategoryArr);

    return mappedDependencies;

    // Fetch categories from `categoriesResponse` based on workflow ID
  };
  const getNodeDependencyList = async () => {
    const dependenciesResponse = await apiRequest(
      API_ENDPOINTS.WORKFLOW_RULES_LIST,
      HTTP_METHODS.POST,
      { deletedAt: 'null' },
      token,
      handleLogout
    );
    if (dependenciesResponse.success) {
      const labels = await findRelevantLabelsList(dependenciesResponse.data);

      setNodeDependencies(labels);
    }
  };

  useEffect(() => {
    setIsNodeDependencyButton(true);
    setIsNodeDependencyListVisible(true);
    // getNodeDependencyList();
  }, []); // Runs when `selectedTab` changes
  const handleCategorySelect = async (data) => {
    try {
      setSelectedCategory(data.name);
      setSelectedCategoryId(data.id);
      setSelectedCategorySlug(data.slug);
      const savedWorkflowsResponse = await apiRequest(
        API_ENDPOINTS.WORKFLOW_LIST,
        HTTP_METHODS.POST,
        { workflow_category: data.slug, deleted_at: 'null' },
        token,
        handleLogout
      );

      if (!Array.isArray(savedWorkflowsResponse)) {
        console.error('Invalid response format:', savedWorkflowsResponse);
        setWorkflowOptions([]);
        return; // Exit early
      }

      const savedWorkflowsval = savedWorkflowsResponse.reduce((acc, item) => {
        if (!acc[item.workflow_category]) {
          acc[item.workflow_category] = [];
        }
        acc[item.workflow_category].push(item);
        return acc;
      }, {});

      setsavedWorkflows(savedWorkflowsval);
      setIsCategoryOpen(false);
      console.log(data.name, 'data.name');

      // Get workflows for the selected category
      const savedWorkflowCategory = savedWorkflowsval[data.slug] || []; // Default to empty array

      // Extract workflow names for the selected category
      const savedWorkflowCategoryArr = savedWorkflowCategory.map(
        (item) => item.workflow_name
      );

      const savedWorkflowNodeLabelsArr = savedWorkflowCategory.flatMap((item) =>
        item.workflow.nodes.map((node) => ({
          id: node.id, // Include the ID
          label: node.data.label, // Include the label
        }))
      );
      setsavedWorkflowNodeLabels(savedWorkflowNodeLabelsArr);
      setWorkflowOptions(savedWorkflowCategory);
      console.log(
        workflowOptions,
        savedWorkflowCategory,
        'savedWorkflowCategory'
      );
    } catch (error) {
      console.error('Error fetching workflows:', error);
      setWorkflowOptions([]);
    }

    // Reset other states
    setSelectedWorkflow(null);

    setSelectedNode(null);
    setSelectedDependentNode(null);
    setIsCategoryOpen(false);
  };

  const handleWorkflowSelect = (workflow) => {
    setSelectedWorkflow(workflow.workflow_name);
    setSelectedWorkflowId(workflow.id);
    setSelectedNode(null);
    setSelectedDependentNode(null);
    setNodeOptions(savedWorkflowNodeLabels);
    setIsWorkflowOpen(false);
  };

  const handleNodeSelect = (node) => {
    setSelectedNode(node.label);
    setSelectedNodeId(node.id);

    console.log(nodeOptions, 'nodeOptions');

    const filteredDependentNodeOptions = nodeOptions.filter(
      (item) => item.id !== node.id
    );

    setDependentNodeOptions(filteredDependentNodeOptions);
    setIsNodeOpen(false);
  };

  const handleDependentNodeSelect = (node) => {
    setSelectedDependentNode(node.label);
    setSelectedDependentNodeId(node.id);
    setIsDependentNodeOpen(false);
  };

  /*const findRelevantLabels = (dependenciesResponse, optionsData) => {
    if (!Array.isArray(dependenciesResponse) || dependenciesResponse.length === 0) return [];

    const findLabel = (obj, key, value) => {
        if (!obj || !value) return null;
        const found = Object.values(obj).find(item => String(item[key]) === String(value));
        return found ? found.name : null;  // Using 'name' instead of 'label'
    };

    return dependenciesResponse.map(dep => ({
        id: dep.id,
        savedWorkflowCategory: findLabel(optionsData, "id", dep.wfw_category),
    }));
};*/

  //console.log(findRelevantLabels(dependenciesResponse, optionsData));
  /*const findRelevantLabels = (dependenciesResponse,optionsData, savedWorkflows, workflowOptions, nodeOptions) => {

    console.log(dependenciesResponse,optionsData, savedWorkflows, workflowOptions, nodeOptions) 
    if (!Array.isArray(dependenciesResponse) || dependenciesResponse.length === 0) return [];

    const findLabel = (obj, key, value) => {
        if (!obj || !value) return null;
        const found = Object.values(obj).find(item => String(item[key]) === String(value));
        return found ? found.name : null;  // Using 'name' instead of 'label'
    };

  const findWorkFlowDetails = (obj, key, value) => {
    if (!Array.isArray(obj) || obj.length === 0 || !value) return { workflowName: null, nodeLabel: null };

    const foundWorkflow = obj.find(item => String(item[key]) === String(value));

    if (!foundWorkflow) return { workflowName: null, nodeLabel: null };

    return {
        workflowName: foundWorkflow.workflow_name || null,  // Extract workflow name
        nodeLabel: foundWorkflow.workflow?.nodes.find(node => node.id === value)?.data.label || null
    };
};

const findNodeLabel = (obj, key, value) => {
  if (!obj || !value) return null;
  const found = Object.values(obj).find(item => String(item[key]) === String(value));
  return found ? found.label : null;  // Using 'name' instead of 'label'
};

return dependenciesResponse.map(dep => {
    const { workflowName, nodeLabel } = findWorkFlowDetails(workflowOptions, "id", dep.wfw_id);

    return {
        id: dep.id,
        workflowCategory: findLabel(optionsData, "id", dep.wfw_category),
        workflowName: workflowName,  // Extracted from workflowOptions
        nodeLabel: findNodeLabel(nodeOptions, "id", dep.wfw_node_id),
        nodeDependentLabel: findNodeLabel(nodeOptions, "id", dep.wfw_node_dependent_id),  // Extracted from workflowOptions
    };
});

};*/

  /*const onSave = () => {

    console.log("Saving data...");
    setIsNodeDependencyListVisbie(true)
    console.log("Category:", selectedCategory);
    console.log("Workflow:", selectedWorkflow);
    console.log("Node:", selectedNode);
    console.log("Dependent Node:", selectedDependentNode);
    const newDependency = {
        Category: selectedCategory,
        Workflow: selectedWorkflow,
        Node: selectedNode,
        DependentNode: selectedDependentNode,
      };

      if (editNodeDependencyIndex !== null) {
        // Edit existing item
        const updatedNodeDependencies= [...nodeDependencies];
        updatedNodeDependencies[editNodeDependencyIndex] = newDependency;
        setNodeDependencies(updatedNodeDependencies);
        setEditNodeDependencyIndex(null);
      } else {
        // Add new item
        setNodeDependencies([...nodeDependencies, newDependency]);
    }

    setSelectedCategory(null);
    setSelectedWorkflow(null);
    setSelectedNode(null);
    setSelectedDependentNode(null);
    setIsNodeDependencyButton(true);
   //setSelectedWorkflow("");
   // setExpectedOutput("");

    //setIsPromptButton(true);
    //setIsPromptListVisible(true);
    // Implement save logic here (e.g., API call, state update, etc.)
  };*/

  const onSave = async () => {
    console.log('Saving data...');
    const newDependency = {
      wfwCategory: selectedCategoryId,
      wfwId: selectedWorkflowId,
      wfwNodeId: selectedNodeId,
      wfwNodeDependentId: selectedDependentNodeId,
    };
    const replaceIdsWithNames = (message, idMap) => {
      return Object.entries(idMap).reduce(
        (msg, [id, name]) => msg.replaceAll(`"${id}"`, `"${name}"`),
        message
      );
    };
    try {
      let response;
      if (editNodeDependencyIndex !== null) {
        // Edit existing dependency
        const updatedNodeDependencies = nodeDependencies.map((dep, index) =>
          index === editNodeDependencyIndex ? newDependency : dep
        );
        console.log(updatedNodeDependencies, 'updatedNodeDependencies');
        const updateUrl = `${API_ENDPOINTS.UPDATE_WORKFLOW}/${editNodeDependencyIndex}`;
        response = await apiRequest(
          updateUrl,
          HTTP_METHODS.PUT,
          newDependency,
          token,
          handleLogout
        );

        setEditNodeDependencyIndex(null);
      } else {
        // Add new dependency via API
        response = await apiRequest(
          API_ENDPOINTS.CREATE_WORKFLOW,
          HTTP_METHODS.POST,
          newDependency,
          token,
          handleLogout
        );

        if (response.success) {
          setNodeDependencies((prev) => [...prev, response.data]);
        }
      }

      const relaventIdNames = {
        [selectedCategoryId]: selectedCategory,
        [selectedWorkflowId]: selectedWorkflow,
        [selectedNodeId]: selectedNode,
        [selectedDependentNodeId]: selectedDependentNode,
      };

      if (!response.success) {
        const errorMessage = response.error || 'Failed to save node dependency';
        const formattedError = replaceIdsWithNames(
          errorMessage,
          relaventIdNames
        );
        throw new Error(formattedError);
        //throw new Error(response.error || "Failed to save node dependency");
      }

      // Fetch latest dependencies from the backend
      /* const dependenciesResponse = await apiRequest(
        API_ENDPOINTS.WORKFLOW_RULES_LIST,
        HTTP_METHODS.POST,
        { deletedAt: "null" },
        token,
        handleLogout
      );

            if (dependenciesResponse.success) { 
              
              const labels = findRelevantLabels(dependenciesResponse.data, optionsData, savedWorkflows,workflowOptions, nodeOptions);
              console.log(labels,'labels **********************************8')
              setNodeDependencies(labels);

            //  setNodeDependencies(dependenciesResponse.data);

            }*/

      // Reset form fields and state
      setSelectedCategory(null);
      setSelectedWorkflow(null);
      setSelectedNode(null);
      setSelectedDependentNode(null);

      setSnackbarMessage('Node dependency saved successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setIsNodeDependencyButton(true);
      setIsNodeDependencyListVisible(true);
      getNodeDependencyList();
    } catch (error) {
      console.error('Error saving node dependency:', error);
      setSnackbarMessage(error.message || 'An error occurred');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsNodeDependencyButton(true);
    }
  };

  const toggleMenu = (setter, ...others) => {
    setter((prev) => !prev);
    others.forEach((otherSetter) => otherSetter(false));
  };

  const editNodeDependency = async (data) => {
    console.log(data, 'data');

    setSelectedCategory(data.workflowCategory);
    setSelectedCategoryId(data.workflowCategoryId);
    setSelectedWorkflow(data.workflowName);
    setSelectedWorkflowId(data.workflowNameId);

    setSelectedNode(data.nodeLabel);
    setSelectedNodeId(data.nodeId);
    setSelectedDependentNode(data.nodeDependentLabel);
    setSelectedDependentNodeId(data.nodeDependentId);

    setEditNodeDependencyIndex(data.id);

    const savedWorkflowsResponse = await apiRequest(
      API_ENDPOINTS.WORKFLOW_LIST,
      HTTP_METHODS.POST,
      { workflow_category: data.workflowCategory, deleted_at: 'null' },
      token,
      handleLogout
    );

    const savedWorkflowsval = savedWorkflowsResponse.reduce((acc, item) => {
      if (!acc[item.workflow_category]) {
        acc[item.workflow_category] = [];
      }
      acc[item.workflow_category].push(item);
      return acc;
    }, {});

    setsavedWorkflows(savedWorkflowsval);
    setIsCategoryOpen(false);

    // Get workflows for the selected category
    const savedWorkflowCategory =
      savedWorkflowsval[data.workflowCategory] || []; // Default to empty array

    const savedWorkflowNodeLabelsArr = savedWorkflowCategory.flatMap((item) =>
      item.workflow.nodes.map((node) => ({
        id: node.id, // Include the ID
        label: node.data.label, // Include the label
      }))
    );
    setsavedWorkflowNodeLabels(savedWorkflowNodeLabelsArr);
    setWorkflowOptions(savedWorkflowCategory);
    setNodeOptions(savedWorkflowNodeLabelsArr);

    console.log(nodeOptions, 'nodeOptions');
    const filteredDependentNodeOptions = savedWorkflowNodeLabelsArr.filter(
      (item) => item.id !== data.nodeLabel
    );

    //setSelectedDependentNode(node.label);
    //setSelectedDependentNodeId(node.id);
    setDependentNodeOptions(filteredDependentNodeOptions);

    setIsNodeDependencyListVisible(false);
    setIsNodeDependencyButton(false);
    // setIsNodeDependencyListVisbie(false);
  };

  const deleteNodeDependency = async (data) => {
    // const updatedDependencies = nodeDependencies.filter((_, i) => i !== index);
    //setNodeDependencies(updatedDependencies);

    const deleteCategoryUrl = `${API_ENDPOINTS.DELETE_WORKFLOW}/${data.id}`;
    try {
      const response = await apiRequest(
        deleteCategoryUrl,
        HTTP_METHODS.DELETE,
        {},
        token,
        handleLogout
      );
      if (!response.success) {
        setSnackbarMessage('Failed to delete Node Dependency');
        setSnackbarSeverity('error'); // Change "failure" to "error"
        setSnackbarOpen(true);
        throw new Error('Failed to delete Node Dependency');
      }
      const updatedDependencies = nodeDependencies.filter(
        (node) => node.id !== data.id
      );
      setNodeDependencies(updatedDependencies);
      setSnackbarMessage('Node Dependency deleted successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      console.log('Node Dependency deleted successfully');
    } catch (error) {
      console.error('Error deleting Node Dependency:', error);
    }
  };

  return (
    <>
      {!isNodeDependencyListVisible ? (
        <div>
          {/* Category Selection */}
          <div
            className={`${styles.selectMenu}  ${isCategoryOpen ? styles.active : ''}`}
          >
            <label className={styles.cardlabel}>Select Category</label>
            <div
              className={styles.selectBtn}
              onClick={() => {
                setIsCategoryOpen(!isCategoryOpen);
                setIsWorkflowOpen(false);
                setIsNodeOpen(false);
                setIsDependentNodeOpen(false);
              }}
            >
              <span className={styles.sBtnText}>
                {selectedCategory ? selectedCategory : 'Select Category'}
              </span>
              <span className={styles.dropdownicon}>
                {isCategoryOpen ? <FaAngleUp /> : <FaAngleDown />}
              </span>
            </div>
            {isCategoryOpen && (
              <ul className={styles.selectoptions} style={{ width: '100%' }}>
                {Object.values(optionsData).map((data) => (
                  <li
                    className={styles.selectoption}
                    key={data.id} // Use ID as key
                    onClick={() => handleCategorySelect(data)} // Use name & ID
                  >
                    <span className={styles.selectoptionText}>{data.name}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Workflow Selection (Dependent on Category) */}
          {selectedCategory && (
            <div
              className={`${styles.selectMenu}  ${isWorkflowOpen ? styles.active : ''} `}
            >
              <label className={styles.cardlabel}>Select Workflow</label>
              <div
                className={styles.selectBtn}
                onClick={() => {
                  setIsWorkflowOpen(!isWorkflowOpen);
                  setIsCategoryOpen(false);
                  setIsNodeOpen(false);
                  setIsDependentNodeOpen(false);
                }}
              >
                <span className={styles.sBtnText}>
                  {selectedWorkflow || 'select'}
                </span>
                <span className={styles.dropdownicon}>
                  {isWorkflowOpen ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              </div>
              {isWorkflowOpen && (
                <ul className={styles.selectoptions} style={{ width: '100%' }}>
                  {workflowOptions.length > 0 ? (
                    workflowOptions.map((data) => (
                      <li
                        className={styles.selectoption}
                        key={data.id || data.workflow_name} // Fallback key
                        onClick={() => handleWorkflowSelect(data)}
                      >
                        <span className={styles.selectoptionText}>
                          {data.workflow_name}
                        </span>
                      </li>
                    ))
                  ) : (
                    <li className={styles.selectoption}>
                      No Workflow Available
                    </li> // Handle empty state
                  )}
                </ul>
              )}
            </div>
          )}

          {/* Node Selection (Dependent on Workflow) */}
          {selectedWorkflow && (
            <div
              className={`${styles.selectMenu} ${isNodeOpen ? styles.active : ''}`}
            >
              <label className={styles.cardlabel}>Select Node</label>
              <div
                className={styles.selectBtn}
                onClick={() => {
                  setIsNodeOpen(!isNodeOpen);
                  setIsCategoryOpen(false);
                  setIsWorkflowOpen(false);
                  setIsDependentNodeOpen(false);
                }}
              >
                <span className={styles.sBtnText}>
                  {selectedNode || 'select'}
                </span>
                <span className={styles.dropdownicon}>
                  {isNodeOpen ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              </div>
              {isNodeOpen && (
                <ul className={styles.selectoptions} style={{ width: '100%' }}>
                  {nodeOptions.map((data) => (
                    <li
                      className={styles.selectoption}
                      key={data.id}
                      onClick={() => handleNodeSelect(data)}
                    >
                      <span className={styles.selectoptionText}>
                        {data.label}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {/* Dependent Node Selection (Dependent on Node) */}
          {selectedNode && (
            <div
              className={`${styles.selectMenu}  ${isDependentNodeOpen ? styles.active : ''}`}
            >
              <label className={styles.cardlabel}>Select Dependent Node</label>
              <div
                className={styles.selectBtn}
                onClick={() => {
                  setIsDependentNodeOpen(!isDependentNodeOpen);
                  setIsCategoryOpen(false);
                  setIsWorkflowOpen(false);
                  setIsNodeOpen(false);
                }}
              >
                <span className={styles.sBtnText}>
                  {selectedDependentNode || 'select'}
                </span>
                <span className={styles.dropdownicon}>
                  {isDependentNodeOpen ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              </div>
              {isDependentNodeOpen && (
                <ul className={styles.selectoptions} style={{ width: '100%' }}>
                  {dependentNodeOptions.map((data) => (
                    <li
                      className={styles.selectoption}
                      key={data.id}
                      onClick={() => handleDependentNodeSelect(data)}
                    >
                      <span className={styles.selectoptionText}>
                        {data.label}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {/* Save Button */}
          <button
            onClick={() => onSave()}
            className={`${styles.saveButton} ${
              selectedCategory &&
              selectedWorkflow &&
              selectedNode &&
              selectedDependentNode
                ? styles.saveButtonEnabled
                : styles.saveButtonDisabled
            }`}
            disabled={
              !selectedCategory ||
              !selectedWorkflow ||
              !selectedNode ||
              !selectedDependentNode
            }
          >
            {editNodeDependencyIndex !== null ? 'Update' : 'Save'}
          </button>
        </div>
      ) : (
        <div className={styles.nodeDependencyCard}>
          {nodeDependencies.length > 0 ? (
            <div>
              <h3 className={styles.addedPromptTitle}>
                Depended Nodes in node
              </h3>
              {nodeDependencies.map((data) => (
                <div key={data.id} className={styles.promptContainer}>
                  <div className={styles.promptContent}>
                    <p className={styles.promptText}>{data.workflowName}</p>
                    <hr className={styles.divider} />
                    <p className={styles.expectedOutput}>
                      {data.workflowCategory}
                    </p>
                    <hr className={styles.divider} />
                    <p className={styles.expectedOutput}>{data.nodeLabel}</p>
                    <hr className={styles.divider} />
                    <p className={styles.expectedOutput}>
                      {data.nodeDependentLabel}
                    </p>
                  </div>
                  <div className={styles.iconContainer} style={{ margin: 10 }}>
                    <FaPencilAlt
                      onClick={() => editNodeDependency(data)}
                      className={styles.editIcon}
                      style={{ display: 'none' }} // Hide the icon
                    />
                    <FaTrashAlt
                      onClick={() => deleteNodeDependency(data)}
                      className={styles.deleteIcon}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: 'center',
                marginBottom: '30px',
                color: '#888',
                fontWeight: 'bold',
              }}
            >
              No Nodes Available
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default NodeDependencyDropDown;
